import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSessionPanelsStore = defineStore('session-panels', () => {
    const usersPanel = ref(false);
    const roundsPanel = ref(false);

    function toggleUsersPanel() {
        usersPanel.value = !usersPanel.value;
    }

    function toggleRoundsPanel() {
        roundsPanel.value = !roundsPanel.value;
    }

    return {
        usersPanel,
        roundsPanel,
        toggleUsersPanel,
        toggleRoundsPanel,
    };
});
